/*
Import all child theme specific scripts here
*/

//import cards from "./custom/cards.js";
import "./custom/navbar.js"; // Import navbar functionality
// ajax-search.js is enqueued separately in enqueues.php
import "./libs/splide/splide_custom_simple_initialize.js"; // Import and execute team.js
import "./custom/load-more-posts.js"; // Import load more posts functionality
//import "./custom/dual-section.js"; // Import dual section functionality
import "./custom/hero.js"; // Import hero functionality
